import Api from '@/services/Api'

export default {
    getAllParametrosContabilizacion(){
        return Api().get('parametrosContabilizacion/getAll')
    },
    getParametrosContabilizacionById(id){
        return Api().get('/parametrosContabilizacion/getById/'+id)
    },
    getParametrosContabilizacionByFechaContb(fecha){
        return Api().get('/parametrosContabilizacion/getByFecha/'+fecha)
    },
    getAllFechasParametrosContabilizacion(){
        return Api().get('/parametrosContabilizacion/getAllFechas')
    },
    createParametrosContabilizacion(datos){
        return Api().post('/parametrosContabilizacion/create',datos)
    },
    cargaLastPlantilla(datos){
        return Api().post('/parametrosContabilizacion/cargaUltimaPlantilla',datos)
    },
    updateCreateParametrosContabilizacion(datos){
        return Api().post('/parametrosContabilizacion/updateCreate',datos)
    },
    updateParametrosContabilizacion(datos){
        return Api().put('/parametrosContabilizacion/update',datos)
    },
    deleteParametrosContabilizacion(id){
        return Api().delete('/parametrosContabilizacion/delete/'+id)
    }
}